import { Box } from '@mui/material'
import { useContext } from 'react'

import { GeotokensSettingsContext } from '../../Contexts'
import InView from './InView'

const SettingsList: React.FC = () => {
  const { settingsList } = useContext(GeotokensSettingsContext)

  return (
    <Box alignItems="stretch" display="flex" flexDirection="column" flexGrow={1} justifyContent="center">
      {settingsList
        ? settingsList?.map((settings) => {
            return (
              <Box flexGrow={1} key={settings.quadkey.toHex()}>
                <InView quadkey={settings.quadkey} />
              </Box>
            )
          })
        : null}
    </Box>
  )
}

export default SettingsList
